import {
  ContactTeaser,
  FileTeaser,
  ImageTeaser,
  MainTeaser,
  PlaceTeaser,
} from "shared/components";
import { IInfoBlockItem } from "shared/types";

export const getInfoBlockItemTeaser = (type: IInfoBlockItem) => {
  switch (type) {
    case IInfoBlockItem.contact:
      return ContactTeaser;
    case IInfoBlockItem.place:
      return PlaceTeaser;
    case IInfoBlockItem.file:
      return FileTeaser;
    case IInfoBlockItem.image:
      return ImageTeaser;
    default:
      return MainTeaser;
  }
};
